import {
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';
import * as cts from '../../../constants/ui/svg';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getToken } from 'helpers';
import { rankingAction } from 'slices/rankingSlice';
import beside from '../../../assets/images/beside.png';
import slide from '../../../assets/images/slide.png';
import { Switch, Input, Modal } from 'antd';
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import SortableItem from './SortableItem';
import { errorToast, successToast } from 'helpers';

type RankingChildItem = {
  id: number;
  shop_id: number;
  name: string;
  value: number;
  status: number;
  layout_ranking: number;
  created_at: string;
  updated_at: string;
};

type RankingItem = {
  id: number;
  shop_id: number;
  name: string;
  value: number;
  status: number;
  layout_ranking: number;
  created_at: string;
  updated_at: string;
  child: RankingChildItem[];
};
type Props = {};
const SortByRank = forwardRef(({}: Props, ref) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const token = getToken() as string;

  const shopSettings = useAppSelector((state) => state.shopSetting.shopSetting);
  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const orderByImagesSliderRank = useAppSelector((state) => state.ranking.orderByImagesSliderRank);
  const orderByRankingInPosRanking = useAppSelector(
    (state) => state.ranking.orderByRankingInPosRanking
  );
  const [listRankingSort, setListRankingSort] = useState<RankingItem[]>([]);
  const [openChooseLayout, setOpenChooseLayout] = useState(false);
  const [selectedLayoutRanking, setSelectedLayoutRanking] = useState(0);
  const [itemRanking, setItemRanking] = useState<RankingChildItem | null>(null);

  // const [rankingSlideIntervalSecond, setRankingSlideIntervalSecond] = useState(0);

  const toggleOpen = (id: number | string, checked: boolean): void => {
    setListRankingSort((prev) => {
      const newList = structuredClone(prev); // deep clone
      for (const item of newList) {
        if (item.id === Number(id)) {
          item.status = checked ? 1 : 0;
          return newList;
        }
        for (const child of item.child || []) {
          if (child.id === Number(id)) {
            child.status = checked ? 1 : 0;
            return newList;
          }
        }
      }
      return prev;
    });
  };
  // ---------------ORDER_SORT_BY------------------
  // const sensors = useSensors(useSensor(PointerSensor));

  // const handleMainDragEnd = (event: any) => {
  //   const { active, over } = event;

  //   if (!over || active.id === over.id) return; // kiểm tra null

  //   const oldIndex = listRankingSort.findIndex((i) => i.id === active.id);
  //   const newIndex = listRankingSort.findIndex((i) => i.id === over.id);

  //   if (oldIndex === -1 || newIndex === -1) return; // kiểm tra không tìm thấy id

  //   setListRankingSort(arrayMove(listRankingSort, oldIndex, newIndex));
  // };

  // const handleSubDragEnd = (sectionId: number) => (event: any) => {
  //   const { active, over } = event;
  //   if (!over || active.id === over.id) return;

  //   setListRankingSort((prev) =>
  //     prev.map((section: any) => {
  //       if (section.id !== sectionId) return section;

  //       const oldIdx = section.child.findIndex((item: any) => item.id === active.id);
  //       const newIdx = section.child.findIndex((item: any) => item.id === over.id);

  //       if (oldIdx === -1 || newIdx === -1) return section;

  //       const newChildren = arrayMove(section.child, oldIdx, newIdx);
  //       return { ...section, child: newChildren };
  //     })
  //   );
  // };
  // ---------------ORDER_SORT_BY------------------

  const handleTransformAndSetList = useCallback(() => {
    {
      const transformAndSort = (data: any) => {
        const children = data.filter((item: any) =>
          data.some((parent: any) => item.name.startsWith(parent.name + '_'))
        );

        const topLevel = data.filter((item: any) => !children.includes(item));

        const nested = topLevel.map((top: any) => {
          const childItems = data.filter((item: any) => item?.name.startsWith(top?.name + '_'));
          const sortedChildren = childItems.sort((a: any, b: any) => a?.value - b?.value);
          return {
            ...top,
            child: sortedChildren,
          };
        });

        const sortedNested = nested.sort((a: any, b: any) => a.value - b.value);

        return sortedNested;
      };
      const newList = transformAndSort([...orderByRankingInPosRanking]);
      setListRankingSort(newList);
    }
  }, [orderByRankingInPosRanking]);
  function flattenNestedData(nestedData: any) {
    const flatData: any[] = [];

    nestedData.forEach((parent: any) => {
      const { child, ...parentWithoutChild } = parent;
      flatData.push(parentWithoutChild);

      if (child && Array.isArray(child)) {
        child.forEach((childItem) => {
          flatData.push(childItem);
        });
      }
    });

    return flatData;
  }
  // -----------------CHANGE_ORDER_BY_IMAGES_SLIDER_RANK-----------------------------
  const profitItem = flattenNestedData([...listRankingSort]).find((item) => item.name === 'PROFIT');
  const nominationItem = flattenNestedData([...listRankingSort]).find(
    (item) => item.name === 'NOMINATION'
  );
  const chooseArr = flattenNestedData([...listRankingSort])
    .filter((item) => {
      if (profitItem?.status === 0 && item.name.includes('PROFIT')) return false;
      if (nominationItem?.status === 0 && item.name.includes('NOMINATION')) return false;
      return true;
    })
    .filter((item) => item.status !== 0 && item.name !== 'PROFIT' && item.name !== 'NOMINATION');
  const mergedArr = (() => {
    // Lấy order lớn nhất trong orderByImagesSliderRank
    const maxOrder = Math.max(...orderByImagesSliderRank.map((o: any) => o.order_by), 0);

    // Giữ nguyên item không có order_by_ranking_id
    const result = orderByImagesSliderRank.filter((item: any) => !item.order_by_ranking_id);

    //Giữ nguyên item có order_by_ranking_id và tồn tại trong chooseArr
    const chooseIds = chooseArr.map((c) => c.id);
    result.push(
      ...orderByImagesSliderRank.filter(
        (item: any) => item.order_by_ranking_id && chooseIds.includes(item.order_by_ranking_id)
      )
    );

    //Thêm các item từ chooseArr chưa có trong orderByImagesSliderRank
    const orderIds = orderByImagesSliderRank.map((o: any) => o.order_by_ranking_id).filter(Boolean);

    const missingChoose = chooseArr.filter((c) => !orderIds.includes(c.id));

    missingChoose.forEach((item, index) => {
      result.push({
        created_at: item.created_at,
        updated_at: item.updated_at,
        images_slider_id: null,
        images_slider: null,
        order_by: maxOrder + index + 1,
        order_by_ranking: item,
        order_by_ranking_id: item.id,
        second_change: 30,
        shop_id: item.shop_id,
        type: 1,
      });
    });

    return result;
  })();
  // -----------------CHANGE_ORDER_BY_IMAGES_SLIDER_RANK-----------------------------

  const onSave = async () => {
    try {
      // if (rankingSlideIntervalSecond !== shopSettings?.data?.second_change_ranking) {
      //   dispatch(
      //     shopSettingActions.updateShopSettings({
      //       token,
      //       data: {
      //         shop_id: selectShop.id,
      //         status: 1,
      //         nomination_fee: shopSettings?.data?.nomination_fee || 0,
      //         sub_nomination_fee: shopSettings?.data?.sub_nomination_fee || 0,
      //         support_nomination_fee: shopSettings?.data?.support_nomination_fee || 0,
      //         companion_fee: shopSettings?.data?.companion_fee || 0,
      //         second_change_ranking: rankingSlideIntervalSecond,
      //       },
      //     })
      //   );
      // }
      const isEqual =
        JSON.stringify(flattenNestedData([...listRankingSort])) ===
        JSON.stringify(orderByRankingInPosRanking);
      const isSame =
        mergedArr.length === orderByImagesSliderRank.length &&
        mergedArr.every((m: any) =>
          orderByImagesSliderRank.some(
            (o: any) =>
              o.order_by_ranking_id === m.order_by_ranking_id &&
              o.order_by === m.order_by &&
              o.second_change === m.second_change
          )
        );
      if (!isEqual || !isSame) {
        const profitStatus = flattenNestedData([...listRankingSort]).find(
          (item) => item.name === 'PROFIT'
        )?.status;
        const nominationStatus = flattenNestedData([...listRankingSort]).find(
          (item) => item.name === 'NOMINATION'
        )?.status;

        // Tạo mảng mới
        const newData = flattenNestedData([...listRankingSort]).map((item) => {
          if (item.name.includes('PROFIT') && profitStatus === 0) {
            return { ...item, status: 0 };
          }
          if (item.name.includes('NOMINATION') && nominationStatus === 0) {
            return { ...item, status: 0 };
          }
          return item;
        });
        const data = {
          order_by_ranking: newData,
          shop_id: selectShop.id,
        };
        dispatch(rankingAction.updateOrderByRankingInPosRanking({ token, data: data }));
        dispatch(
          rankingAction.updateOrderByImagesSliderRanking({
            token,
            data: { shop_id: selectShop?.id, input: mergedArr },
          })
        );
        setTimeout(() => {
          successToast('正常に更新されました');
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useImperativeHandle(ref, () => ({
    onSave,
  }));
  useEffect(() => {
    handleTransformAndSetList();
  }, [orderByRankingInPosRanking]);
  // useEffect(() => {
  //   // if (shopSettings?.data?.second_change_ranking !== rankingSlideIntervalSecond) {
  //   setRankingSlideIntervalSecond(Number(shopSettings?.data?.second_change_ranking || 0));

  //   // }
  // }, [shopSettings?.data?.second_change_ranking]);\
  useEffect(() => {
    if (token && selectShop?.id) {
      dispatch(
        rankingAction.fetchOrderByRankingInPosRanking({
          token,
          params: { shop_id: selectShop.id },
        })
      );
    } else {
      dispatch(
        rankingAction.fetchOrderByRankingInPosRanking({
          token,
          params: { permission: 'master' },
        })
      );
    }
  }, [dispatch, selectShop?.id, token]);
  useEffect(() => {
    if (token && selectShop?.id) {
      dispatch(
        rankingAction.getOrderByImagesSLiderRanking({
          token,
          params: { shop_id: selectShop.id },
        })
      );
    } else {
      dispatch(
        rankingAction.getOrderByImagesSLiderRanking({
          token,
          params: { permission: 'master' },
        })
      );
    }
  }, [dispatch, selectShop?.id, token]);

  return (
    <div className="flex flex-col max-h-[50vh] pt-[12px] px-[16px]">
      <span className="text-[#252B37] text-[20px] notosans_bold">{t('SORT_BY_RANK')}</span>
      <span className="text-[16px] text-[#252B37] notosans_bold mt-[16px]">{t('SORT')}</span>

      {/* <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleMainDragEnd}
      >
        <SortableContext
          items={listRankingSort?.map((i) => i.id)}
          strategy={verticalListSortingStrategy}
        > */}
      {listRankingSort?.map((section: RankingItem) => (
        // <SortableItem key={section.id} id={section.id}>
        // {({ listeners }) => (
        <button
          key={section?.id}
          className="mt-[12px] bg-white border-solid border border-[#D5D7DA] rounded-[8px] w-[57%] flex flex-col px-[24px]"
        >
          <div className="py-[16px] flex items-center justify-between">
            <div className="flex items-center">
              {/* <span {...listeners}>{cts.bar}</span> */}
              <span className=" text-[#252B37] text-[16px] notosans_normal">
                {t(`${section.name}`)}
              </span>
            </div>

            {/* <Switch
              className="switch_rank"
              // defaultChecked
              checked={section?.status === 1}
              onChange={(checked) => toggleOpen(section.id, checked)}
            /> */}
          </div>

          {section.status === 1 && (
            // <DndContext
            //   sensors={sensors}
            //   collisionDetection={closestCenter}
            //   onDragEnd={handleSubDragEnd(section.id)}
            // >
            //   <SortableContext
            //     items={section.child?.map((i: any) => i.id)}
            //     strategy={verticalListSortingStrategy}
            //   >
            <>
              {section?.child.map((child: RankingChildItem, index: any) => (
                <button
                  key={index}
                  className={`${
                    index === 0 ? 'border-t border-b' : ''
                  } border-solid bg-white border-[#D5D7DA] py-[16px] flex items-center justify-between px-[48px] w-full`}
                >
                  <div className="flex items-center">
                    {/* <span {...listeners}>{cts.bar}</span> */}
                    <span className="text-[#252B37] text-[16px] notosans_normal">
                      {t(`${child.name}`)}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <button
                      className=""
                      onClick={() => {
                        setItemRanking(child);
                        setOpenChooseLayout(true);
                      }}
                    >
                      {cts.iconLayout}
                    </button>
                    {/* <Switch
                      className="switch_rank"
                      defaultChecked
                      checked={child.status === 1}
                      onChange={(checked) => toggleOpen(child.id, checked)}
                    /> */}
                  </div>
                </button>
              ))}
            </>
            //   </SortableContext>
            // </DndContext>
          )}
        </button>
        // )}
        // </SortableItem>
      ))}
      {/* </SortableContext>
      </DndContext> */}

      {/* <div className="h-px w-full bg-[#D5D7DA] mt-[16px] mb-[16px]"></div> */}
      {/* <span className="text-[#252B37] text-[16px] notosans_bold">
        {t('NUMBER_OF_SECONDS_SWITCH')}
      </span>
      <div className="pb-[20px]">
        <Input
          value={
            rankingSlideIntervalSecond === 0 || isNaN(rankingSlideIntervalSecond)
              ? ''
              : rankingSlideIntervalSecond.toString()
          }
          className="mt-[8px] w-[31%] h-[44px] rounded-[8px] mb-[20px] border border-solid border-[#D5D7DA] px-[10px] !focus:border-[#D5D7DA]"
          suffix={t('SECONDS')}
          onChange={(e: any) => {
            e = e.target.value.replace(/[^0-9]/g, '');
            setRankingSlideIntervalSecond(Number(e));
          }}
        />
      </div> */}
      <Modal
        centered
        visible={openChooseLayout}
        onOk={() => setOpenChooseLayout(false)}
        onCancel={() => setOpenChooseLayout(false)}
        className="modal_review_img !w-[644px]"
      >
        <div className="flex flex-col">
          <div className="flex items-center justify-between h-[56px] px-[16px] border-b border-[#D0D5DD] border-solid">
            <span className="text-[#1D2939] text-[20px] notosans_bold">レイアウト</span>
            <button
              onClick={() => setOpenChooseLayout(false)}
              className="text-[16px] notosans_medium text-[#666687]"
            >
              閉じる
            </button>
          </div>
          <div className="p-[16px] flex items-center border-b border-[#D0D5DD] border-solid">
            <button
              onClick={() => {
                if (itemRanking?.id) {
                  setItemRanking({
                    id: itemRanking?.id,
                    shop_id: itemRanking?.shop_id,
                    name: itemRanking?.name,
                    value: itemRanking?.value,
                    status: itemRanking?.status,
                    created_at: itemRanking?.created_at,
                    updated_at: itemRanking?.updated_at,
                    layout_ranking: 0,
                  });
                }
              }}
              className={`${
                itemRanking?.layout_ranking !== 1
                  ? 'bg-[#F9F5FF] border border-solid border-[#666687]'
                  : 'border border-solid border-[#D5D7DA]'
              } flex flex-col items-center justify-center rounded-[8px] p-[12px] w-fit`}
            >
              <img src={beside} className="w-[276px] h-[160px] " />
              <div className="flex items-center">
                <span>{itemRanking?.layout_ranking !== 1 ? cts.checkActive : cts.check}</span>
                <span className="text-[14px] text-[#252B37] notosans_normal ml-[8px]">
                  {t('BESIDE')}
                </span>
              </div>
            </button>
            <button
              onClick={() => {
                if (itemRanking?.id) {
                  setItemRanking({
                    id: itemRanking?.id,
                    shop_id: itemRanking?.shop_id,
                    name: itemRanking?.name,
                    value: itemRanking?.value,
                    status: itemRanking?.status,
                    created_at: itemRanking?.created_at,
                    updated_at: itemRanking?.updated_at,
                    layout_ranking: 1,
                  });
                }
              }}
              className={`${
                itemRanking?.layout_ranking === 1
                  ? 'bg-[#F9F5FF] border border-solid border-[#666687]'
                  : 'border border-solid border-[#D5D7DA]'
              } flex flex-col items-center justify-center rounded-[8px] p-[12px] w-fit ml-[12px]`}
            >
              <img src={slide} className="w-[276px] h-[160px] " />
              <div className="flex items-center">
                <span>{itemRanking?.layout_ranking === 1 ? cts.checkActive : cts.check}</span>
                <span className="text-[14px] text-[#252B37] notosans_normal ml-[8px]">
                  {t('SLIDER')}
                </span>
              </div>
            </button>
          </div>
          <div className="p-[16px] items-center justify-center">
            <button
              onClick={() => {
                if (itemRanking?.id) {
                  const arrNew = flattenNestedData([...listRankingSort]).map((x: any) =>
                    x?.id === itemRanking?.id ? { ...x, ...itemRanking } : x
                  );
                  const data = {
                    order_by_ranking: arrNew,
                    shop_id: selectShop.id,
                  };
                  dispatch(rankingAction.updateOrderByRankingInPosRanking({ token, data: data }));
                  setTimeout(() => {
                    setOpenChooseLayout(false);
                    successToast('レイアウトが正常に更新されました');
                  }, 1000);
                }
              }}
              className="w-full h-[44px] rounded-[8px] flex items-center justify-center text-white text-[16px] notosans_medium bg-[#666687]"
            >
              保存
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
});
export default SortByRank;
